
<script>
export default {
  computed: {
    tutor_condition () {
      return this.$store.getters.tutor_condition
    }
  },
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getTutor_condition(to.params.id)
    })
  },
  methods: {
    getTutor_condition (id) {
      this.$store.dispatch('getTutor_condition', id)
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Tutor_condition.vue?f9d593e4